import baseAPI from "@/api/base";
import { CreateProductNameDto, GetProductName, UpdateProductNameDto } from "@/dtos/ProductName.dto";
import { GET_PRODUCT_NAME_URL } from "@/utils/urls";
import { AxiosResponse } from "axios";

class ProductName {
  static getProductNames = async (getProductName: GetProductName): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PRODUCT_NAME_URL, {
      params: getProductName,
    });
    return response;
  };

  static createProductName = async (data: CreateProductNameDto): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(GET_PRODUCT_NAME_URL, data);
    return response;
  };

  static updateProductName = async (
    id: string,
    data: UpdateProductNameDto
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(`${GET_PRODUCT_NAME_URL}/${id}`, data);
    return response;
  };

  static deleteProductName = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${GET_PRODUCT_NAME_URL}/${id}`);
    return response;
  };
}

export default ProductName;
